import { render, staticRenderFns } from "./ShopTuiguang.vue?vue&type=template&id=95dedf20&scoped=true"
import script from "./ShopTuiguang.vue?vue&type=script&lang=js"
export * from "./ShopTuiguang.vue?vue&type=script&lang=js"
import style0 from "./ShopTuiguang.vue?vue&type=style&index=0&id=95dedf20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dedf20",
  null
  
)

export default component.exports